import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2';
import { insertScore, updateReport, getScore } from "../../scoreservice";
import { sendReport, extractReportIdFromResponse, resolveReportRole } from "../../functions/sendReport";


function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const isFromMobileApp = (() => {
    const mobileParam = queryParams.get('fromMobileApp');
    if (mobileParam === 'true' || mobileParam === '1') return true;
    try {
      return sessionStorage.getItem('fromMobileApp') === 'true';
    } catch {
      return false;
    }
  })();
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");
  const navigate = useNavigate();
  const [isLogoSet, SetIsLogoSet] = useState(false);

  function handleError(msg) {
    Swal.fire({ icon: "error", title: "Oops...", text: msg });
  }

  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    }).then(result => {
      return result; // Ensure we return the result
    });
  };

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          id: Math.floor(Math.random() * 100000),
          email: `${randomString}@gmail.com`,
          userId: randomString,
          firstName: randomString,
          lastName: randomString,
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass",
          organizationId: "demobypass",
          roles: "demoRoles",
          reportId: `Report${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        const headers = {
          'client-secret': process.env.REACT_APP_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        const method = "POST";
        if (["POST", "PUT"].includes(method)) {
          headers["Idempotency-Key"] = uuidv4();
          console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
        }

        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    let companyLogo = "";
                    if (!responseOrg.data?.organization?.companyLogo) {
                      companyLogo = process.env.REACT_APP_EM_LOGO;
                    } else {
                      const s3Source = process.env.REACT_APP_S3_SOURCE || "";
                      const base = s3Source.endsWith("/") ? s3Source : `${s3Source}/`;
                      companyLogo = `${base}${responseOrg.data.organization.companyLogo}`;
                    }

                    updateHeader({
                      imageUrl: companyLogo,
                      backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                    });
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                });
              loginCheck(response, source);
            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  function loginCheck(response, source) {

    // Clear any existing game state when entering intro page
    try {
      sessionStorage.removeItem("gameState_v1");
    } catch (e) { /* ignore */ }
    console.log("loginCheck", response);

    const userId = role === 'GUEST_USER' ? response.data.data.id : response.data.data.userId;

    let name = `${response.data.data.firstName} ${response.data.data.lastName}`;
    let email;
    let token;

    if (role === 'GUEST_USER') {
      token = "";
      if (!response.data.data.firstName) {
        if (response.data.data.email) {
          name = response.data.data.email.split('@')[0];
          email = response.data.data.email;
        } else if (response.data.data.employeeId) {
          name = response.data.data.employeeId;
          email = response.data.data.employeeId;
        } else {
          name = 'Guest';
        }
      } else {
        name = response.data.data.firstName;
        email = response.data.data.email || response.data.data.employeeId;
      }
    } else {
      email = response.data.data.email;
      token = response.data.data.token;
    }

    const userData = {
      userId: userId,
      sessionId: response.data.data.sessionId,
      organizationId: response.data.data.organizationId,
      roles: response.data.data.roles || response.data.data.role,
      name: name,
      gameId: response.data.data.gameId,
      email: email,
      expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
      source: source,
      token: token
    };
    console.log("userData", userData);

    if (queryParams.get('admin')) {

      navigate(
        `/admin?sessionId=${userData.sessionId}&userId=${userData.userId}&gameId=${userData.gameId}&organizationId=${userData.organizationId}`
      );
    } else {

      // Fetch theme data (same in both cases)
      const themeUrl = `${process.env.REACT_APP_BACKEND_URL}/getThemeData?sessionId=${userData.sessionId}&userId=${userData.userId}&organizationId=${userData.organizationId}`;
      console.log("themeUrl", themeUrl);
      fetch(themeUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((json) => {
          // setThemeData(json);
          sessionStorage.setItem('themeData', JSON.stringify(json));
          setThemeData(json);
          console.log(json);
          // callReportAPIAndContinue(userData);
          callPhpReportAPI(userData);

        })
        .catch((error) => {
          console.error('Theme fetch failed:', error);
          handleError('Unable to load the game theme. Please try again.');
        });

    }

  }

   function callPhpReportAPI(userData) {


    let reportData = {
      userId: userData.userId,
      sessionId: userData.sessionId,
      organizationId: userData.organizationId,
      roles: userData.roles,
      name: userData.name,
      email: userData.email,
      gameId: userData.gameId,
      points: 0,
      time: "00:00"

    };

    const reportData1 = {
      userId: userData.userid || userData.userId,
      sessionId: userData.sessionId,
      organizationId: userData.organizationId
    };

    console.log("reportData1--------", reportData1);

    getScore(reportData1)
      .then(res => {
        if (!res) return;

        const data = res.data || {};
        const isGameOver =
          data.gameover === true ||
          data.gameover === "1" ||
          String(data.gameover).toLowerCase() === "true";

        if (res?.status === "success" && isGameOver && !isFromMobileApp) {
          Swal.fire({
            icon: "info",
            text: "You have already played",
            confirmButtonText: "OK"
          }).then(() => {
            window.location.href = process.env.REACT_APP_BASE_URL;
          });
          return;
        }

        // Not already played (no record or gameover not true) – proceed with insert
        insertScore(reportData).then((res) => {
            console.log("Insert response:", res);

            if (userData.source == "demo") {
              setIsLoggedIn(true);
              sessionStorage.setItem('userData', JSON.stringify(userData));

            } else {
              if (res.status === "exists") {
                console.log("Already inserted, record:", res.data);
                // The stage row only has DB column names (userid, user_type, ...): keep the fresh login
                // payload (userId, gameId, source, token) and just take over the saved reportId.
                const savedReportId = res.data?.reportId || res.data?.reportid || res.data?.report_id;
                callReportAPIAndContinue({ ...userData, ...(savedReportId && { reportId: String(savedReportId) }) });
              } else if (res.status === "success") {
                console.log("New score inserted.");
                callReportAPIAndContinue(userData);
              } else {
                handleError(res.message || "Something went wrong. Please try again.");
              }
            }
          });
      })
      .catch(err => {
        console.error(err);
      });


  }

  // Same as the reference game: add the report when there is no reportId yet, otherwise reuse it.
  async function callReportAPIAndContinue(userData) {
    const updatedUserData = { ...userData };
    const reportRole = resolveReportRole(userData);
    console.log("updatedUserData", updatedUserData);

    const finish = () => {
      sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
      setIsLoggedIn(true);
    };

    // reportId already exists (returning player): nothing to add
    if (updatedUserData.reportid || updatedUserData.reportId) {
      console.log("reportId already exists in userData, skipping report add.");
      finish();
      return;
    }

    try {
      const response = await sendReport({
        role: reportRole,
        token: userData.token,
        gameId: userData.gameId,
        name: userData.name,
        sessionId: userData.sessionId,
        userId: userData.userId,
        organizationId: userData.organizationId,
        points: 0,
        time: reportRole === "GUEST_USER" ? "00:00:00" : "NA",
      });
      const reportId = extractReportIdFromResponse(response);
      if (reportId) {
        updatedUserData.reportId = reportId;
        console.log("Report ID set:", reportId);
        const updateRes = await updateReport(updatedUserData);
        console.log("Report Id Update response:", updateRes);
      } else {
        console.warn("Report add returned no report id:", response);
      }
    } catch (error) {
      // do not block the player: the end-of-game report will add it if it is still missing
      console.error('Report add failed:', error.response?.data || error.message);
    }
    finish();
  }


  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {

  if (!themeData) return;

  const body = document.body;

  const updateBackground = () => {

    const isMobile = window.innerWidth <= 768;
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    let backgroundImage;

    if (isMobile && isPortrait) {
      // ✅ Mobile Portrait
      backgroundImage = themeData.background_mob;
    } else {
      // ✅ Landscape Mobile + Desktop
      backgroundImage = themeData.background_desk;
    }

    if (body.classList.contains("common-bg")) {
      body.style.backgroundImage = `url(${backgroundImage})`;
    }
  };

  updateBackground(); // initial load
  window.addEventListener("resize", updateBackground);

  setRiddlerusLogo(themeData.logo);
  SetIsLogoSet(true);

  return () => {
    window.removeEventListener("resize", updateBackground);
  };

}, [themeData]);

  useEffect(() => {
    if (themeData?.game_title?.trim()) {
      document.title = themeData.game_title.trim();
    }
  }, [themeData]);

  useEffect(() => {
    setTimeout(function () {
      if (queryParams.get('save')) {
        let getThemeData = sessionStorage.getItem('themeData');
        getThemeData = JSON.parse(getThemeData);
        console.log(getThemeData);
        let body = document.body;
        setIsLoggedIn(true);
        if (getThemeData) {
          if (body.classList.contains('common-bg')) {
            console.log(getThemeData.background_desk);
            console.log(getThemeData.logo);
            body.style.backgroundImage = `url(${getThemeData.background_desk})`;
            setRiddlerusLogo(getThemeData.logo);
            SetIsLogoSet(true);
          } else {
            console.log("not able to find common bg");
          }
          console.log("sessioin state updated!");
        }
      }
    }, 1000);
  }, []);

  return (
    <>
      <div className="login-main-container" style={{ textAlign: "center" }}>

        {
          (isLogoSet) ?
            <div className="login-main-container1" style={{ textAlign: "center", marginBottom: "30px" }}>
              <img src={riddlerusLogo} className="login-logo" />
            </div>
            :
            <>
              <div className="loader">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            </>

        }
        {isLoggedIn ? (
          <div style={{ textAlign: "center" }}>
            <Link to="/intro">
              <button
                type="button"
                className="begin-play-img1"
                style={{
                  backgroundColor: themeData?.button_color || "#000",
                  color: themeData?.button_text_color || "#fff"
                }}
              >
                Begin Play
              </button>
            </Link>
          </div>
        ) : null}

      </div>
    </>
  );
}

export default Login;